/**
 * PDP qty stepper. Single delegated click listener on document.
 * Reads min/max from input attrs. Clamps value. Disables buttons at bounds.
 * Exposes window.BB.syncQtyStepper(input) so variant change can re-sync after max changes.
 */
(function () {
  'use strict';

  var BB = window.BB || (window.BB = {});

  function bounds(input) {
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    var max = input.hasAttribute('max') ? parseInt(input.max, 10) : NaN;
    return { min: min, max: isNaN(max) ? null : max };
  }

  function clamp(val, b) {
    if (isNaN(val)) val = b.min;
    if (val < b.min) val = b.min;
    if (b.max !== null && val > b.max) val = b.max;
    return val;
  }

  function sync(input) {
    var stepper = input.closest('.qty-stepper');
    if (!stepper) return;
    var b = bounds(input);
    var val = clamp(parseInt(input.value, 10), b);
    if (String(val) !== input.value) input.value = String(val);
    var dec = stepper.querySelector('[data-qty-decrement]');
    var inc = stepper.querySelector('[data-qty-increment]');
    var atMin = val <= b.min;
    var atMax = b.max !== null && val >= b.max;
    var minTip = 'Minimum quantity is ' + b.min;
    var maxTip = b.max !== null ? 'Only ' + b.max + ' available' : '';
    if (dec) {
      dec.disabled = atMin;
      if (atMin) dec.setAttribute('title', minTip); else dec.removeAttribute('title');
    }
    if (inc) {
      inc.disabled = atMax;
      if (atMax) inc.setAttribute('title', maxTip); else inc.removeAttribute('title');
    }
    var scope = stepper.closest('form') || stepper.parentElement;
    var hint = scope ? scope.querySelector('[data-qty-hint]') : null;
    if (hint) {
      var msg = atMax ? maxTip : (atMin ? minTip : '');
      hint.textContent = msg;
    }
  }

  BB.syncQtyStepper = sync;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-increment], [data-qty-decrement]');
    if (!btn) return;
    var stepper = btn.closest('.qty-stepper');
    if (!stepper) return;
    var input = stepper.querySelector('[data-qty-input]');
    if (!input) return;
    e.preventDefault();
    var b = bounds(input);
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = b.min;
    val += btn.hasAttribute('data-qty-increment') ? 1 : -1;
    input.value = String(clamp(val, b));
    sync(input);
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-qty-input]')) sync(e.target);
  });

  function initAll() {
    document.querySelectorAll('.qty-stepper [data-qty-input]').forEach(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('variant:change', function () {
    document.querySelectorAll('.qty-stepper [data-qty-input]').forEach(sync);
  });
})();
